<template>
	<section>
		<!-- Componentes externos -->
    <crear-actualizar-sistema />
    <h3 class="primary--text"><v-icon color="primary">business</v-icon> Sistemas</h3>
		<v-card>
			<v-card-text>
				<crud-table
					:headers="headers"
          :url="url"
          :filters="filters"
          :data-graphql="dataGraphql"
					:graphql="graphql"
				>
					<!-- Template injectable de la cabecera de la tabla -->
					<template slot="buttons">
            <v-tooltip bottom>
             <v-btn color="primary" dark
               @click.native.stop="crearActualizarSistema({})"
               slot="activator"
             ><v-icon dark>add</v-icon> {{$t('common.add') }}</v-btn>
             <span>Agregar Sistema</span>
           </v-tooltip>
          </template>

					<!-- Template de filas y columnas -->
					<template slot="items" slot-scope="items">
						<!-- Agregar las columnas que consideré necesarias -->
            <!-- <td class="text-xs-center">{{ items.item.nombre }}</td> -->
            <td class="text-xs-center">{{ items.item.descripcion }}</td>
            <td class="nowrap text-xs-center">
              <v-tooltip bottom>
                <v-btn
                  icon
                  slot="activator"
                  color="primary"
                  @click.native="crearActualizarSistema(items.item)">
                  <v-icon>edit</v-icon>
                </v-btn>
                <span>Editar registro</span>
              </v-tooltip>
              <v-tooltip bottom>
                <v-btn
                  icon
                  slot="activator"
                  color="error"
                  @click="deleteItem(items.item.id, 'sistema')">
                  <v-icon>delete</v-icon>
                </v-btn>
                <span>Eliminar registro</span>
              </v-tooltip>
            </td>
          </template>

				</crud-table>
			</v-card-text>
		</v-card>
	</section>
</template>

<script>
import CrudTable from '@/common/util/crud-table/CrudTable.vue'; // Componente Tabla Dinámica
import crud from '@/common/util/crud-table/mixins/crud-table'; // Funciones y Metodos
import CrearActualizarSistema from '../dialogs/CrearActualizarSistema' // Componente de creación y actualización

export default {
	// Importación de métodos y funciones de un archivo mixin 
	mixins: [crud],
	// Variables iniciales del componente
	data () {
		return {
			url: 'sistemas',
			graphql: true,
			// Cabecera de la tabla
			headers: [
        // { text: 'Nombre de la cabecera', value: 'Campo que deseamos interpolar', align: 'center' },
        { text: 'Nombre o descripción', value: 'descripcion', align: 'center' },
        { text: this.$t('common.actions'), sortable: false, align: 'center' }
      ],
			// Campos solicitados de Graphql(Agregar los que necesite)
			dataGraphql: `
        id
        id_estado
        descripcion
        path
        _user_created
        _user_updated
        _created_at
        _updated_at
      `,
			// Filtros del componente CrudTable ejemplo:
			// {
			// 	field: 'Campo definido en Graphql',
			// 	label: 'Etiqueta del input generado',
			// 	type: 'text', // Tipo de input en el filtro
			// 	typeG: 'String' // Tipo definido en Graphql
			// }
			filters: []
		}
	},
	// Funcionalidades que se ejecutan al montar el componente
  mounted () {
    // Verificando si el usuario tiene permiso para interactual con el componente
    const rolesPermitidos = [2, 3, 0] // ID's de roles permitidos
    if (!this.$util.permisoRol(rolesPermitidos)) {
      this.$router.push('/403')
    }

    this.$bus.$on('closeDialog', () => {
      this.updateList()
    })
  },
	// Métodos y funciones del componente
	methods: {
		crearActualizarSistema (item) {
			this.$bus.$emit('openDialogCrearActualizarSistema', item)
		}
	},
	// Definición de componentes importados
	components: {
		CrudTable,
		CrearActualizarSistema
	}
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/admin/rol-recurso/components/Sistema.vue